import { RootState } from "../reducers";
import { LicensePlateVinLookupMethods } from "../reducers/reducer-license-plate-vin-lookup";

export const getLicensePlateVinLookupMethod = (state: RootState): LicensePlateVinLookupMethods => state.licensePlateVinLookup.method;

export const getVehicleLookupSearchResults = (state: RootState) => state.licensePlateVinLookup.searchResults;

export const getVehicleLookupLoading = (state: RootState) => state.licensePlateVinLookup.loading;

export const getSelectedVehicleColor = (state: RootState) => state.licensePlateVinLookup.selectedVehicle?.color;

export const getSelectedVehicleFuelType = (state: RootState) => state.licensePlateVinLookup.selectedVehicle?.fuelType;

export const getSelectedVehicle = (state: RootState) => state.licensePlateVinLookup.selectedVehicle?.vehicle;

export const getVinSearchResults = (state: RootState) => state.licensePlateVinLookup?.VinSearchResults;

export const getMethod = (state: RootState) => state.licensePlateVinLookup.method;

export const getLicensePlateFailedCount = (state: RootState) => state.licensePlateVinLookup.licensePlateFailedCount;

export const getVinFailedCount = (state: RootState) => state.licensePlateVinLookup.vinFailedCount;
